<template>
    <v-dialog
        v-model:model-value="modelValue"
        max-width="1000"
        @click:outside="$emit('update:modelValue', false)"
    >
        <v-window v-model="step">
            <!-- Select Person/Organisation -->
            <v-window-item :value="1">
                <v-card>
                    <slot name="title">
                        <v-card-title class="headline"
                            >{{ config.label || 'LABEL' }} {{ $t('assign') }}</v-card-title
                        >
                    </slot>
                    <slot>
                        <v-card-text>
                            <v-card tile min-height="180px" :loading="loading">
                                <v-card-text>
                                    <div v-if="newAdress">
                                        <v-card-title class="pb-0">
                                            <div v-if="newAdress.typ === 'organisation'">
                                                {{ newAdress.organisation_name }}
                                            </div>
                                            <div v-else>
                                                {{ newAdress.anrede }} {{ newAdress.display_name }}
                                                {{ newAdress.vorname }} <br />{{
                                                    newAdress.anrede2
                                                }}
                                                {{ newAdress.nachname2 }}
                                                {{ newAdress.vorname2 }}
                                            </div>
                                        </v-card-title>
                                        <v-card-text>
                                            <div v-if="newContactAdress">
                                                {{ newContactAdress.display_name }}
                                                {{ newContactAdress.vorname }}
                                            </div>

                                            <div v-if="newAdress.typ === 'organisation'">
                                                {{ newAdress.anrede }} {{ newAdress.nachname }}
                                                {{ newAdress.vorname }}
                                            </div>
                                            <div v-if="newAdress.adresszusatz">
                                                {{ newAdress.adresszusatz }}
                                            </div>
                                            <div v-if="newAdress.adresse">
                                                {{ newAdress.adresse }}
                                            </div>
                                            <div v-if="newAdress.postfach">
                                                {{ newAdress.postfach }}
                                            </div>
                                            <div v-if="newAdress.plz_ort">
                                                {{
                                                    newAdress.laendercode &&
                                                    newAdress.laendercode !== 'CH'
                                                        ? newAdress.laendercode + '-'
                                                        : ''
                                                }}{{ newAdress.plz_ort }}
                                            </div>
                                            <div v-if="newAdress.tel_1">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-phone</v-icon
                                                >
                                                <kp-link tel :href="newAdress.tel_1">
                                                    {{ formattedPhoneNumber(newAdress.tel_1) }}
                                                </kp-link>
                                                {{ newAdress.tel_2 ? '/' : '' }}
                                                <kp-link
                                                    v-if="newAdress.tel_2"
                                                    tel
                                                    :href="newAdress.tel_2"
                                                >
                                                    {{ formattedPhoneNumber(newAdress.tel_2) }}
                                                </kp-link>
                                            </div>
                                            <div v-else-if="newAdress.organisation_tel_1">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-phone</v-icon
                                                >
                                                <kp-link tel :href="newAdress.organisation_tel_1">
                                                    {{
                                                        formattedPhoneNumber(
                                                            newAdress.organisation_tel_1,
                                                        )
                                                    }}
                                                </kp-link>
                                                {{ newAdress.organisation_tel_2 ? '/' : '' }}
                                                <kp-link
                                                    v-if="newAdress.organisation_tel_2"
                                                    tel
                                                    :href="newAdress.organisation_tel_2"
                                                >
                                                    {{
                                                        formattedPhoneNumber(
                                                            newAdress.organisation_tel_2,
                                                        )
                                                    }}
                                                </kp-link>
                                            </div>
                                            <div v-if="newAdress.email">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-at</v-icon
                                                >
                                                <kp-link mailto :href="newAdress.email" />
                                            </div>
                                            <div v-if="newAdress.organisation_email">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-at</v-icon
                                                >
                                                <kp-link
                                                    mailto
                                                    :href="newAdress.organisation_email"
                                                />
                                            </div>
                                        </v-card-text>
                                    </div>
                                    <div v-else>
                                        <v-card-subtitle>{{
                                            $t('address_selection')
                                        }}</v-card-subtitle>
                                    </div>
                                </v-card-text>
                            </v-card>
                            <AdressenGrid
                                :edit="false"
                                :dense="true"
                                :selectable="true"
                                :height="300"
                                :addbtn="$t('new_address')"
                                :headerwidths="{
                                    typ: '5%',
                                    name: '18%',
                                    vorname: '18%',
                                    adresse: '25%',
                                    land: '0%',
                                    plz: '14%',
                                    ort: '18%',
                                    action: '0%',
                                }"
                                :gesuch-id="getGesuchId()"
                                :selection="newAdress"
                                :typfilter="identFilter"
                                @selection="selectionChanged"
                                @new-address="$emit('new-address')"
                            ></AdressenGrid>
                        </v-card-text>
                    </slot>
                    <slot name="actions">
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn text color="decline" :disabled="loading" @click="cancel">
                                {{ $t('cancel') }}
                            </v-btn>
                            <v-btn
                                v-if="newAdress && newAdress.typ === typPerson"
                                color="action"
                                variant="flat"
                                :loading="loading"
                                :disabled="!newAdress"
                                @click="assign"
                            >
                                <v-icon left>fas fa-check</v-icon>
                                {{ $t('assign') }}
                            </v-btn>
                            <v-btn
                                v-else
                                color="action"
                                variant="flat"
                                :loading="loading"
                                :disabled="!newAdress"
                                @click="next"
                            >
                                <div>{{ $t('next') }}</div>
                            </v-btn>
                        </v-card-actions>
                    </slot>
                </v-card>
            </v-window-item>

            <!-- If an Organisation is selected in the first place, select a contact Person now -->
            <v-window-item :value="2">
                <v-card>
                    <slot name="title">
                        <v-card-title class="headline">
                            {{
                                $t('add_contact', {
                                    org: newAdress ? newAdress.organisation_name : '',
                                })
                            }}
                        </v-card-title>
                    </slot>
                    <slot>
                        <v-card-text>
                            <v-card tile min-height="180px" :loading="loading">
                                <v-card-text>
                                    <div v-if="newAdress">
                                        <v-card-title class="pb-0">
                                            <div v-if="newAdress.typ === 'organisation'">
                                                {{ newAdress.organisation_name }}
                                            </div>
                                            <div v-else>
                                                {{ newAdress.anrede }} {{ newAdress.display_name }}
                                                {{ newAdress.vorname }} <br />{{
                                                    newAdress.anrede2
                                                }}
                                                {{ newAdress.nachname2 }}
                                                {{ newAdress.vorname2 }}
                                            </div>
                                        </v-card-title>
                                        <v-card-text>
                                            <div v-if="newContactAdress">
                                                {{ newContactAdress.display_name }}
                                                {{ newContactAdress.vorname }}
                                            </div>

                                            <div v-if="newAdress.typ === 'organisation'">
                                                {{ newAdress.anrede }} {{ newAdress.nachname }}
                                                {{ newAdress.vorname }}
                                            </div>
                                            <div v-if="newAdress.adresszusatz">
                                                {{ newAdress.adresszusatz }}
                                            </div>
                                            <div v-if="newAdress.adresse">
                                                {{ newAdress.adresse }}
                                            </div>
                                            <div v-if="newAdress.postfach">
                                                {{ newAdress.postfach }}
                                            </div>
                                            <div v-if="newAdress.plz_ort">
                                                {{
                                                    newAdress.laendercode &&
                                                    newAdress.laendercode !== 'CH'
                                                        ? newAdress.laendercode + '-'
                                                        : ''
                                                }}{{ newAdress.plz_ort }}
                                            </div>
                                            <div v-if="newAdress.tel_1">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-phone</v-icon
                                                >
                                                <kp-link tel :href="newAdress.tel_1">
                                                    {{ formattedPhoneNumber(newAdress.tel_1) }}
                                                </kp-link>
                                                {{ newAdress.tel_2 ? '/' : '' }}
                                                <kp-link
                                                    v-if="newAdress.tel_2"
                                                    tel
                                                    :href="newAdress.tel_2"
                                                >
                                                    {{ formattedPhoneNumber(newAdress.tel_2) }}
                                                </kp-link>
                                            </div>
                                            <div v-else-if="newAdress.organisation_tel_1">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-phone</v-icon
                                                >
                                                <kp-link tel :href="newAdress.organisation_tel_1">
                                                    {{
                                                        formattedPhoneNumber(
                                                            newAdress.organisation_tel_1,
                                                        )
                                                    }}
                                                </kp-link>
                                                {{ newAdress.organisation_tel_2 ? '/' : '' }}
                                                <kp-link
                                                    v-if="newAdress.organisation_tel_2"
                                                    tel
                                                    :href="newAdress.organisation_tel_2"
                                                >
                                                    {{
                                                        formattedPhoneNumber(
                                                            newAdress.organisation_tel_2,
                                                        )
                                                    }}
                                                </kp-link>
                                            </div>
                                            <div v-if="newAdress.email">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-at</v-icon
                                                >
                                                <kp-link mailto :href="newAdress.email" />
                                            </div>
                                            <div v-if="newContactAdress && newContactAdress.email">
                                                <v-icon size="x-small" class="pr-1"
                                                    >fas fa-at</v-icon
                                                >
                                                <kp-link mailto :href="newContactAdress.email" />
                                            </div>
                                        </v-card-text>
                                    </div>
                                    <div v-else>
                                        <v-card-subtitle>{{
                                            $t('address_selection')
                                        }}</v-card-subtitle>
                                    </div>
                                </v-card-text>
                            </v-card>
                            <v-checkbox
                                v-if="!forceContact"
                                v-model="showOrgGrid"
                                :label="
                                    $t('contact_for_org', {
                                        org: newAdress ? newAdress.organisation_name : '',
                                    })
                                "
                            ></v-checkbox>
                            <AdressenGrid
                                v-if="forceContact || showOrgGrid"
                                :edit="false"
                                :dense="true"
                                :selectable="true"
                                :height="300"
                                :addbtn="$t('add_contact')"
                                :headerwidths="{
                                    typ: '5%',
                                    name: '18%',
                                    vorname: '18%',
                                    adresse: '25%',
                                    land: '0%',
                                    plz: '14%',
                                    ort: '18%',
                                    action: '0%',
                                }"
                                :gesuch-id="getGesuchId()"
                                :selection="newContactAdress"
                                :typfilter="typPerson"
                                @selection="contactSelectionChanged"
                                @new-address="$emit('new-contact')"
                            ></AdressenGrid>
                        </v-card-text>
                    </slot>
                    <slot name="actions">
                        <v-card-actions>
                            <v-btn text color="decline" :disabled="loading" @click="onBackButton">
                                {{ $t('back') }}
                            </v-btn>
                            <v-spacer></v-spacer>

                            <v-btn text color="decline" :disabled="loading" @click="cancel">
                                {{ $t('cancel') }}
                            </v-btn>
                            <v-btn
                                color="action"
                                :loading="loading"
                                variant="flat"
                                :disabled="
                                    (forceContact && !newContactAdress) ||
                                    (showOrgGrid && !newContactAdress)
                                "
                                @click="assign"
                                prepend-icon="fas fa-check"
                            >
                                {{ $t('assign') }}
                            </v-btn>
                        </v-card-actions>
                    </slot>
                </v-card>
            </v-window-item>
        </v-window>
    </v-dialog>
</template>

<script setup lang="ts">
import { Gesuch } from '@/models/Gesuch'
import { Adresse, AdresseTyp } from '@/models/Adresse'
import { formatTelefonNumber } from '@/helpers/tools'
import AdressenGrid from '@/components/adressen-grid.vue'
import KpLink from '@/components/link.vue'
import { computed, ref, watch, type Ref } from 'vue'

const modelValue = defineModel<boolean>()

const {
    loading = false,
    ident,
    gesuch,
    adresse,
} = defineProps<{
    loading?: boolean
    ident: string
    gesuch: Gesuch
    adresse: Adresse | null
}>()
const newAdress: Ref<Adresse | null> = ref(null)
const newContactAdress: Ref<Adresse | null> = ref(null)
const step: Ref<number> = ref(1)
const typPerson: Ref<AdresseTyp> = ref(AdresseTyp.PERSON)
const showOrgGrid: Ref<boolean> = ref(false)

const config = computed(() => {
    if (ident) {
        return gesuch.config?.config?.kontakte?.get(ident)
    }
    return null
})
const identFilter = computed(() => {
    switch (ident) {
        case 'unternehmer':
            return AdresseTyp.ORGANISATION
        case 'kontakt':
            return AdresseTyp.PERSON
        default:
            return null
    }
})
const forceContact = computed(() => {
    return ident === 'unternehmer' || ident === 'bevollmaechtigter'
})

watch(
    () => adresse,
    (adr: Adresse | null) => {
        newAdress.value = adr
        if (adr?.typ === 'organisation') {
            step.value = 2
            emit('oganisation-selected', newAdress.value)
        }
    },
    { deep: true },
)

watch(showOrgGrid, (val: boolean) => {
    if (!val) {
        contactSelectionChanged(null)
    }
})

const emit = defineEmits<{
    (e: 'assign', newAdress: Adresse | null, newContactAdress: Adresse | null): void
    (e: 'close'): void
    (e: 'oganisation-selected', newAdress: Adresse | null): void
    (e: 'new-contact'): void
    (e: 'new-address'): void
}>()

async function assign() {
    emit('assign', newAdress.value, newContactAdress.value)
}
function selectionChanged(adr: Adresse | null) {
    newAdress.value = adr
}
function contactSelectionChanged(adr: Adresse | null) {
    newContactAdress.value = adr
}
function cancel() {
    newAdress.value = adresse
    emit('close')
}
function getGesuchId() {
    return gesuch?.id || null
}
function onBackButton() {
    step.value = 1
    newContactAdress.value = null
}
function formattedPhoneNumber(value: string) {
    return formatTelefonNumber(value)
}
function next() {
    step.value = 2
    emit('oganisation-selected', newAdress.value)
}
</script>

<style scoped>
.v-card__text,
.v-card__title {
    word-break: normal !important;
}
</style>
